import * as Yup from 'yup';

export const ProductManagementValidators = Yup.object().shape({
  id: Yup.string(),
  franchiseId: Yup.string(),
  userId: Yup.string(),
  name: Yup.string().required('* Campo obrigatório'),
  description: Yup.string().required('* Campo obrigatório'),
  image: Yup.object(),
  negotiationQuestions: Yup.array(),
  clientQuestions: Yup.array(),
  shippingQuestions: Yup.array(),
  compaignQuestions: Yup.array(),
});
